// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { LocalstorageKeys } from '../types/enums'
import { IOrderModel, IOrderForm } from '../types/interfaces'
import jsPDF from 'jspdf'
import { approvalStepsStatuses, PL001 } from '../types/constants'
import { printDate } from './Utils'
import { getFormTitle } from './Orders'
import autoTable from 'jspdf-autotable'
import { TFunction } from 'i18next'
import { OrdersFormViewModel, OrderViewModel } from '@ail/orders-api'

export class RequestExportToPDF {
  public static startExport(
    order: OrderViewModel,
    orderForms: OrdersFormViewModel[],
    lang: string,
    t: TFunction
  ) {
    const currentOrder = order
    const found = orderForms.filter((r) => r.id === currentOrder.formId)
    if (found.length < 1) {
      return
    }
    const currentForm = found[0]
    const data = currentOrder.data
    const selectedCompany = currentOrder.company
    const selectedCostCenter = currentOrder.costCenter
    const currentUser = currentOrder.userDisplayName
    const ordersSteps =
      currentOrder?.approvalProcess?.steps.length > 0
        ? currentOrder?.approvalProcess?.steps
        : currentOrder?.approvalProcess?.stepsWithTags
    const rawDataSections = currentForm.sections
    const doc = new jsPDF()
    const headCustomer = [[t('CUSTOMER'), '']]
    const headApprove = [[t('APPROVE/SIGN'), '']]
    const headApproveAdditional = [[t('STEP'), t('USER_NAME'), t('DATE'), t('NOTE')]]

    const rowsCustomer = [
      [t('COMPANY_NAME'), selectedCompany?.companyName],
      [t('COST_CENTER'), selectedCostCenter?.costCenterName],
      [t('USER'), currentUser],
    ]

    const rowsApprove = [
      [t('ID'), currentOrder?.id],
      [
        t('STATUS'),
        currentOrder && currentOrder?.approvalProcess
          ? t(currentOrder?.approvalProcess.status.toUpperCase())
          : t('DRAFT'),
      ],
    ]
    const rowsApproveAdditional = []
    const rowsApproveAdditional2 = ['']
    ordersSteps?.map(
      (row, index) =>
        row.status !== approvalStepsStatuses.pending &&
        rowsApproveAdditional.push([
          row.step,
          row.userDisplayName,
          printDate(row.timestamp) +
            ' ' +
            new Date(row.timestamp).getHours() +
            ':' +
            (new Date(row.timestamp).getMinutes().toString().length === 1
              ? '0' + new Date(row.timestamp).getMinutes()
              : new Date(row.timestamp).getMinutes()),
          Object.keys(row.notes).length > 0
            ? Object.keys(row.notes)
                .map((k) => row.notes[k])
                .join('; ')
            : null,
        ])
    )
    doc.addImage('/interfleet4u-new2.png', 'PNG', 15, 5, 60, 12)
    doc.setFontSize(13)
    doc.text(getFormTitle(currentForm, lang, true) || currentForm?.name, 150, 13, {
      maxWidth: 90,
      align: 'center',
    })
    autoTable(doc, {
      columnStyles: {
        0: { cellWidth: 40, fontStyle: 'italic', lineWidth: 0.3 },
        1: { lineWidth: 0.3 },
      },
      startY: 25,
      head: headCustomer,
      body: rowsCustomer,
    })
    rawDataSections.map((obj, index) => {
      if (index === 0) {
        return
      }
      if (data[PL001] === 'rad1' && index === 2) {
        return
      }
      const headers = [[obj.tr[lang] || obj.name, '']]
      const rows = []
      currentForm?.formFields.map(
        (field) =>
          field.section === obj.name &&
          rows.push([
            field.tr[lang] || field.label,
            field.type === 'radio'
              ? field.options.filter((option) => option.value === data[field.name])[0]?.tr[lang] ||
                field.options.filter((option) => option.value === data[field.name])[0]?.name
              : field.type === 'checkBox'
              ? data[field.name] === 'true'
                ? t('YES')
                : t('NO')
              : data[field.name]?.split(';base64')[0].split('|')[0],
          ])
      )
      autoTable(doc, {
        columnStyles: {
          0: { cellWidth: 40, fontStyle: 'italic', lineWidth: 0.3 },
          1: { lineWidth: 0.3 },
        },
        startY: (doc as any).lastAutoTable.finalY,
        head: headers,
        body: rows,
      })
    })
    autoTable(doc, {
      columnStyles: {
        0: { cellWidth: 40, fontStyle: 'italic', lineWidth: 0.3 },
        1: { lineWidth: 0.3 },
      },
      head: headApprove,
      body: rowsApprove,
      startY: (doc as any).lastAutoTable.finalY,
      margin: 0,
    })
    autoTable(doc, {
      head: headApproveAdditional,
      body: rowsApproveAdditional.length > 0 ? rowsApproveAdditional : rowsApproveAdditional2,
      startY: (doc as any).lastAutoTable.finalY,
      margin: 0,
      columnStyles: {
        0: { cellWidth: 40, fontStyle: 'italic', lineWidth: 0.3 },
        1: { cellWidth: 60, lineWidth: 0.3 },
        2: { cellWidth: 35, lineWidth: 0.3 },
        3: { lineWidth: 0.3 },
      },
      didParseCell: (tableData) => {
        if (
          rowsApproveAdditional.length === 0 &&
          tableData.row.index === 0 &&
          tableData.row.section === 'body'
        ) {
          tableData.cell.styles.fillColor = [255, 255, 255]
          tableData.cell.styles.lineColor = [255, 255, 255]
        }
      },
    })
    doc.save(
      `I4U_${getFormTitle(currentForm, lang, true) || currentForm.name}_${currentOrder.id}.pdf`
    )
  }
}
